// extracted by mini-css-extract-plugin
module.exports = {"container":"generatedReports_container___adVO","download":"generatedReports_download__lAGVS"};